import React from "react";
import { Navigate } from "react-router-dom";

import { Pages } from "../../app/constants/routes";
import { ROUTE_NAMES } from "../../app/constants/TextConstants";
import {
  ActivityLogIcon,
  BillingIcon,
  CalendarIcon,
  ContactsIcon,
  DocumentsIcon,
  HomeIcon,
  MailsIcon,
  ReportsIcon,
  SupportIcon,
  TimeIcon,
  WorksIcon,
} from "../../components/svg/navIcons/index-svg";
import { ActivityLogView } from "../../features/activityLog/ActivityLogView";
import { InvoicesView } from "../../features/billing/invoices/InvoicesView";
import { CalendarView } from "../../features/calendar/CalendarView";
import { ContactsView } from "../../features/contacts/ContactsView";
import { OrganizationView } from "../../features/contacts/pages/organization/OrganizationView";
import { BankDocView } from "../../features/documents/bankStatements/BankDocView";
import { EmailsView } from "../../features/emails/EmailsView";
import { DocumentsView } from "../../features/files/DocumentsView";
import { HomeAuthView } from "../../features/home/HomeAuthView";
import { SignOutView } from "../../features/main/SignOutView";
import { NotificationView } from "../../features/notifications/NotificationView";
import { ReportsView } from "../../features/reports/ReportsView";
import { SettingsView } from "../../features/settings/SettingsView";
import { SignaturesView } from "../../features/signatures/SignaturesView";
import { SupportView } from "../../features/support/SupportView";
import { TimeView } from "../../features/time/TimeView";
import { UserView } from "../../features/user/UserView";
import { WorkView } from "../../features/work/WorkView";
import { WorksView } from "../../features/works/WorksView";

export const sideNavRouteMap = [
  // Order = owner's Roadmap 1881 (2026-10-23): Home, Contacts, Work, Email, Documents, Time, Billing,
  // Reports, Calendar, Activity log; then Support (owner only, 2026-10-25).
  {
    name: ROUTE_NAMES.home,
    label: "Home",
    path: ROUTE_NAMES.home,
    component: HomeAuthView,
    icon: HomeIcon,
  },
  {
    name: ROUTE_NAMES.clients.index,
    label: "Contacts",
    path: ROUTE_NAMES.clients.index,
    component: ContactsView,
    icon: ContactsIcon,
  },
  {
    name: ROUTE_NAMES.work,
    label: "Work",
    path: ROUTE_NAMES.works,
    component: WorksView,
    icon: WorksIcon,
  },
  {
    name: "mail",
    // Shown as "Email" (Roadmap 1810, owner 2026-10-21); the address stays /mail.
    label: "Email",
    navText: "Email",
    path: "mail",
    component: EmailsView,
    icon: MailsIcon,
  },
  {
    // Right after Email (Roadmap 1868): its icon looked too much like Work's.
    name: "documents",
    label: "Documents",
    path: "documents",
    component: DocumentsView,
    icon: DocumentsIcon,
  },
  {
    name: "time",
    label: "Time",
    path: "time",
    component: TimeView,
    icon: TimeIcon,
  },
  {
    name: "billing",
    label: "Billing",
    path: "billing",
    component: InvoicesView,
    icon: BillingIcon,
  },
  {
    name: "reports",
    label: "Reports",
    path: "reports",
    component: ReportsView,
    icon: ReportsIcon,
  },
  {
    name: ROUTE_NAMES.calendar,
    label: "Calendar",
    path: ROUTE_NAMES.calendar,
    component: CalendarView,
    icon: CalendarIcon,
  },
  {
    name: "activity-log",
    label: "Activity Log",
    navText: "Activity log",
    path: "activity-log",
    component: ActivityLogView,
    icon: ActivityLogIcon,
  },
  // ProCharted's support desk: only for the people the server allows (the owner; MainSidebarNav hides it).
  {
    name: "support",
    label: "Help desk",
    path: "support",
    component: SupportView,
    icon: SupportIcon,
  },
];

// The old Dashboard page was replaced by Reports (owner, Roadmap 1833);
// old links and bookmarks go there.
const DashboardRedirect: React.FC = () => (
  <Navigate to={"/reports"} replace={true} />
);

export const invisibleRouteMap: { name: string; component: React.FC }[] = [
  { name: ROUTE_NAMES.dashboard, component: DashboardRedirect },
  {
    name: "/" + Pages.contact.path + "/:" + Pages.contact.params,
    component: Pages.contact.component,
  },
  { name: "/organization/:organizationId", component: OrganizationView },
  { name: ROUTE_NAMES.documents.bankDoc.index, component: BankDocView },
  { name: ROUTE_NAMES.signOut, component: SignOutView },
  { name: ROUTE_NAMES.user.index, component: UserView },
  { name: "/work/:workId", component: WorkView },
  { name: ROUTE_NAMES.calendar, component: CalendarView },
  { name: ROUTE_NAMES.settings.index, component: SettingsView },
  { name: "/notifications", component: NotificationView },
  { name: "/billing", component: InvoicesView },
  { name: "/mail", component: EmailsView },
  { name: "/signatures", component: SignaturesView },
  {
    name: "/qbo/callback",
    component: () => (
      <Navigate
        to={"/contacts/active-contacts?sortBy=Name&sortOrder=asc&page=1"}
        replace={true}
      />
    ),
  },
];
